import {
    FETCH_APPLICANTS_SUCCESS,
    FETCH_APPLICANT_BY_ID_SUCCESS,
    APPLICANTS_REQUEST_LOADING,
    APPLICANTS_REQUEST_ERRORS
} from "api/menu/hr/applicants/actions";

const initialState = {
    loading: false,
    errors: [],
    applicants: [],
    singleApplicant: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case APPLICANTS_REQUEST_LOADING:
            return { ...state, loading: true };
        case APPLICANTS_REQUEST_ERRORS:
            return { ...state, loading: false, errors: action.payload };
        case FETCH_APPLICANTS_SUCCESS:
            return { ...state, loading: false, applicants: action.payload };
        case FETCH_APPLICANT_BY_ID_SUCCESS:
            return { ...state, loading: false, singleApplicant: action.payload };
        default:
            return state;
    }
}
